module.exports = __webpack_public_path__ + "img/score_right.0ca09db1.png";